<script>
  import SortInput from "./sidebar/SortInput.svelte";
  import SelectInput from "./sidebar/SelectInput.svelte";
  import TextInput from "./sidebar/TextInput.svelte";
  import { profile } from "#src/stores/auth.js";

  export let group;
  export let customColumns;
  export let standardColumns;
  export let groupBy;
  export let groupByDirection;
  export let sortBy;
  export let sortByDirection;
  export let itemFilter;
  export let isCollections = false;

  $: groupOptions = makeGroupOptions(customColumns);
  $: sortOptions = makeSortOptions(customColumns);
  $: filterOptions = makeFilterOptions(customColumns);
  $: checkGroupBy(groupOptions);
  $: checkSortBy(sortOptions);

  function makeGroupOptions(customColumns) {
    const sc = [
      { label: "None", value: "none" },
      ...(isCollections
        ? []
        : [
            { label: "Type", value: "type_id" },
            { label: "Product", value: "type.product_id" },
            { label: "Product Category", value: "category" },
            { label: "Opening", value: "collection_id" },
          ]),
      { label: "Mark", value: "mark" },
      { label: "Width", value: "width" },
      { label: "Height", value: "height" },
      { label: "Quantity", value: "quantity" },
      { label: "Description", value: "description" },
    ].map((col) => {
      if (standardColumns[col.value]?.override) {
        col.label = standardColumns[col.value].override;
      }
      return col;
    });

    return sc.concat(
      customColumns.map((c) => ({
        label: c.name,
        value: `custom_column_data.${c.id}`,
      })),
    );
  }

  function makeFilterOptions(customColumns) {
    const sc = [
      { label: "None", value: undefined },
      { label: "Description", value: "description" },
    ].map((col) => {
      if (standardColumns[col.value]?.override) {
        col.label = standardColumns[col.value].override;
      }
      return col;
    });

    return sc.concat(
      customColumns.map((c) => ({
        label: c.name,
        value: `custom_column_data.${c.id}`,
      })),
    );
  }

  function checkGroupBy(groupOptions) {
    const current = groupOptions.find((c) => c.value === $groupBy);

    if (!current) {
      $groupBy = isCollections ? "none" : "type_id";
    }
  }

  function checkSortBy(sortOptions) {
    const current = sortOptions.find((c) => c.value === $sortBy);

    if (!current) {
      $sortBy = "created_at";
    }
  }

  function makeSortOptions(customColumns) {
    const sc = [
      { label: "Created at", value: "created_at" },
      { label: "Mark", value: "mark" },
      { label: "Width", value: "width" },
      { label: "Height", value: "height" },
      { label: "Quantity", value: "quantity" },
      { label: "Description", value: "description" },
    ].map((col) => {
      if (standardColumns[col.value]?.override) {
        col.label = standardColumns[col.value].override;
      }
      return col;
    });

    return sc.concat(
      customColumns.map((c) => ({
        label: c.name,
        value: `custom_column_data.${c.id}`,
      })),
    );
  }

  function reGroup(evt) {
    $groupBy = evt.detail.sortBy;
    $groupByDirection = evt.detail.sortDirection;
  }

  function reSort(evt) {
    $sortBy = evt.detail.sortBy;
    $sortByDirection = evt.detail.sortDirection;
    group.sortItems($sortBy, $sortByDirection, { prop: "is_collection", value: !isCollections });
  }

  function updateFilterBy(e) {
    const value = e.detail.value;

    if (!value) {
      $itemFilter = null;
    } else {
      $itemFilter = {
        group_id: $group.id,
        field: value,
        operator: "is_equal_to",
        value: "",
      };
    }
  }
</script>

<div class="text-xs flex flex-wrap items-start gap-2 justify-end text-gray-500">
  {#if $group?.project_type !== "product"}
    <div class="w-36">
      <SortInput
        label="Group by"
        sortBy={$groupBy}
        sortDirection={$groupByDirection}
        on:input={reGroup}
        options={groupOptions} />
    </div>
  {/if}
  <div class="w-36">
    <SortInput
      label="Sort by"
      sortBy={$sortBy}
      sortDirection={$sortByDirection}
      on:input={reSort}
      options={sortOptions} />
  </div>
  {#if !isCollections}
    <div class="w-36 space-y-2">
      <SelectInput
        label="Filter by"
        bg={false}
        value={$itemFilter?.field}
        on:input={updateFilterBy}
        options={filterOptions} />
      {#if $itemFilter}
        <SelectInput
          label={null}
          border
          value={$itemFilter?.operator}
          on:input={(e) => ($itemFilter.operator = e.detail.value)}
          options={[
            { label: "Is Equal To", value: "is_equal_to" },
            { label: "Is Not Equal To", value: "is_not_equal_to" },
          ]} />
        <TextInput
          label={null}
          border
          value={$itemFilter?.value}
          on:input={(e) => ($itemFilter.value = e.detail.value)}
          placeholder="Value" />
      {/if}
    </div>
  {/if}
</div>
